import React, {useState, useEffect} from "react";
import { AgGridReact } from "ag-grid-react";
import {
    showAllPortfolios,
    getNewAssets,
    getPortfolioAssets,
    getSecurityTypeDdl,
    getStrategyDdl,
    insertAsset,
    updateSecurities,
    getPortfolioMappings,
    portfolioSummarize,
    checkForDefaultShareClass,
    updateSecurityIgnoreFlag
} from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import moment from "moment";
import { toast } from 'react-toastify';
import { Modal } from "react-bootstrap";

function NewAssets(){
   const [portfolioList, setPortfolioList] = useState([]);
   const [selectedPortfolio, setSelectedPortfolio] = useState(null);
   const [selectedPortfolioId, setSelectedPortfolioId] = useState(0);
   const [checkAllPortfolio, setCheckAllPortfolio] = useState(false);
   const [assetList, setAssetList] = useState([]);
   const [selectedAsset, setSelectedAsset] = useState(null);
   const [selectedAssetId, setSelectedAssetId] = useState(0);
   const [checkAllAssets, setCheckAllAssets] = useState(true);
   const [showAddDrawer, setShowAddDrawer] = useState(false);
   const [unmappedAssetList, setUnmappedAssetList] = useState([]);
   const [selectedUnmappedAssets, setSelectedUnmappedAssets] = useState([]);
   const [mappedAssetList, setMappedAssetList] = useState([]);
   const [selectedMappedAssets, setSelectedMappedAssets] = useState([]);
   const [securityName, setSecurityName] = useState("");
   const [securityType, setSecurityType] = useState([]);
   const [selectedSecurityType, setSelectedSecurityType] = useState(null);
   const [selectedSecurityTypeId, setSelectedSecurityTypeId] = useState(0);
   const [strategy, setStrategy] = useState([]);
   const [selectedStrategy, setSelectedStrategy] = useState(null);
   const [selectedStrategyId, setSelectedStrategyId] = useState(0);
   const [inceptionDate, setInceptionDate] = useState(new Date());
   const [showModel, setShowModel] = useState(false);
   const [isIncludeignore,setIsIncludeIgnore]=useState(true);
   const [ischeckedignore,setIsCheckedIgnore]=useState(false);
    

  const fetchPortfolios = async () => {
        try {
            const list = await sbaAxios({

                url: `${showAllPortfolios}/${checkAllPortfolio}`,
                method: "get",
            })
            setPortfolioList(list)
        }
        catch (e) {
            setPortfolioList([])
        }
    };

   const fetchNewAssets = async() => {
        try{
            const list = await sbaAxios({
                url:getPortfolioAssets,
                params:{
                    portfolioId: checkAllAssets ? null : selectedPortfolioId
                }
            });
            setAssetList(list);
        }
        catch(e){
            setAssetList([])
        }
    };
    useEffect(() => {
        fetchPortfolios();
    }, [checkAllPortfolio]);


   useEffect(()=>{
    fetchNewAssets();
   },[selectedPortfolioId, checkAllAssets]);

   useEffect(()=>{
    const fetchSecurityTypes = async() => {
        try{
            const list = await sbaAxios({
                url:getSecurityTypeDdl,
            });
            setSecurityType(list);
        }
        catch(e){

        }
    };
    const fetchStrategies = async() => {
        try{
            const list = await sbaAxios({
                url:getStrategyDdl
            });
            setStrategy(list);
        }
        catch(e){

        }
    }
    if(showAddDrawer){
        fetchSecurityTypes();
        fetchStrategies();
    }
   },[showAddDrawer]);

   const fetchUnmappedAssets = async (isinclude) => {
    try{
        const list = await sbaAxios({
            url: getNewAssets,
            params:{
                portfolioId:selectedPortfolioId,
                    includeIgnore: isinclude
            }
        });
        setUnmappedAssetList(list);
        setSecurityName(list[0]?.SecurityName);
    }
    catch(e){
        toast.error("Unable to fetch unmapped assets. Please select a portfolio.")
    }
   };

   const fetchMappedAssets = async () => {
    try{
        const list = await sbaAxios({
            url: getPortfolioMappings+`/${selectedPortfolioId}`
        })
        setMappedAssetList(list);
    }
    catch(e){
        toast.error("Unable to fetch mapped assets. Please select a portfolio.")
    }
   };

   useEffect(()=>{
    if(selectedPortfolioId !== 0){
        fetchUnmappedAssets(isIncludeignore);
        fetchMappedAssets();
    }
   },[selectedPortfolioId]);

   const updateIgnoreflag = async (params)=>
   {
   
    try{
        const res = await sbaAxios({
            url:updateSecurityIgnoreFlag,
            params:{
                securityAssetXRefId: params.data.SecurityAssetXRefId,
                ignore: params.newValue
            }
        });
        if(res==true)
        {
            toast.success("Ignore updated succesfully.");
        fetchUnmappedAssets(isIncludeignore);

        }
    }
    catch(e){
        toast.error("Some exception while  update Ignore")
    }
   }

   const SelectAllHeader = (props) => {
    const handleChange = (e) => {
      const checked = e.target.checked;
      const totalRows = props.api.getDisplayedRowCount();
  
      const updatedAssets = [];
  
      for (let i = 0; i < totalRows; i++) {
        const rowNode = props.api.getDisplayedRowAtIndex(i);
        if (rowNode) {
          rowNode.setDataValue("select", checked); // updates cell visually
          const updatedRow = { ...rowNode.data, select: checked };
          updatedAssets.push(updatedRow);
        }
      }
  
      setUnmappedAssetList(updatedAssets); // updates your local data
      setSelectedUnmappedAssets(checked ? [...updatedAssets] : []); // sets selected list
    };
  
    return (
      <span style={{ color: '#545454', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input type="checkbox" onChange={handleChange} />
        Select
      </span>
    );
  };
  

   const unmappedColumnDef = [
    {header:"Account Name", field:"AccountName"},
    {header:"Security", field:"SecurityName", flex:1},
    {
        header: "Select", 
        field: "select", 
        cellRenderer: 'agCheckboxCellRenderer', 
        editable: true,
        headerComponent: 'selectAllHeader',
        headerComponentParams: {
          onToggleAll: (checked) => {
            const updatedData = unmappedAssetList.map(row => ({ ...row, select: checked }));
            setUnmappedAssetList(updatedData);
            setSelectedUnmappedAssets(checked ? [...unmappedAssetList] : []);
          }
        },
      },
    {header:"Ignore", field:"Ignore", cellRenderer: 'agCheckboxCellRenderer', editable:true,onCellValueChanged:(params) => {updateIgnoreflag(params)}}
   ];

   const handleUnmapClick = (params) => {
    setSelectedMappedAssets(params.data);
    setShowModel(true);
   };

   const actionCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i className="fa fa-trash" style={{ color: "red" , margin: "0 8px", cursor: "pointer" }} onClick={() => handleUnmapClick(params)}></i>
      </div>
    );
   };

   const mappedColumnDef = [
    {header:"Account Name", field:"AccountName"},
    {header:"Security", field:"SecurityName", flex:1},
    {header:"Asset", field:"AssetName"},
    {header:"Unmap", field:"unmap", cellRenderer:actionCellRenderer}
   ];

   const handleSelectedPortfolio = (e) => {
    setSelectedPortfolio(e.value);
    setSelectedPortfolioId(e.value?.PortfolioId);
   };

   const handleSelectedAsset = (e) => {
    setSelectedAsset(e.value);
    setSelectedAssetId(e.value?.AssetId);
   };

   const handleSecurityTypeChange = (e) => {
    setSelectedSecurityType(e.value);
    setSelectedSecurityTypeId(e.value?.AssetTypeId);
   };

   const handleStrategyChange = (e) => {
    setSelectedStrategy(e.value);
    setSelectedStrategyId(e.value?.ClassificationId);
   };

//    const handleUnmappedSelection = (params) => {
//     if(params.data.select){
//         const list = [...selectedUnmappedAssets, params.data];
//         setSelectedUnmappedAssets(list);
//     }
//     if(!params.data.select){
//         const list = selectedUnmappedAssets.filter(item => item.select === true);
//         setSelectedUnmappedAssets(list);
//     }
//    };

const handleUnmappedSelection = (params) => {
    const updatedSelectedAssets = [...selectedUnmappedAssets];
  
    if (params.data.select) {
      // If the checkbox is checked, add it to the selected list if not already in it
      if (!updatedSelectedAssets.some(item => item.AccountName === params.data.AccountName)) {
        updatedSelectedAssets.push(params.data);
      }
    } else {
      // If the checkbox is unchecked, remove it from the selected list
      const indexToRemove = updatedSelectedAssets.findIndex(item => item.AccountName === params.data.AccountName);
      if (indexToRemove !== -1) {
        updatedSelectedAssets.splice(indexToRemove, 1);
      }
    }
  
    setSelectedUnmappedAssets(updatedSelectedAssets); // Update state with the new selected list
  };
  

   const handleMapAssets = async() => {
    let xRefId = '';
    for(const item of selectedUnmappedAssets){
        xRefId = xRefId+(item.SecurityAssetXRefId).toString()+',';
    }
    try{
        await sbaAxios({
            url: checkForDefaultShareClass,
            params:{
                assetId: selectedAssetId
            }
        }).then((res)=>{
            if(res)
            {
                sbaAxios({
                    url: updateSecurities,
                    params:{
                        securityAssetXRefIdLst: xRefId,
                        assetId:selectedAssetId
                    }
                });
                toast.success("Selected Assets mapped succesfully.");
                setTimeout(async() => {
                    await fetchUnmappedAssets(isIncludeignore);
                    setSelectedUnmappedAssets([]);
                    await fetchMappedAssets();
                    
                }, 100);
            }
            else
            {
                toast.error("The selected asset doesn’t have a default share class.");
            }

        })
       
    }
    catch(e){
        toast.error("Unable to map selected assets.");
    }
    finally{
        // await fetchUnmappedAssets();
        // await fetchMappedAssets();
        // setSelectedUnmappedAssets([]);
    }
   };

   const handleUnmap = async() => {
    console.log(selectedMappedAssets);
    let xRefId = (selectedMappedAssets.SecurityAssetXRefId).toString()+",";
    try{
        await sbaAxios({
            url: updateSecurities,
            params:{
                securityAssetXRefIdLst: xRefId,
                assetId:0
            }
        });
        toast.success("Selected Asset unmapped succesfully.");
    }
    catch(e){
        toast.error("Unable to unmap selected asset.");
    }
    finally{
        await fetchUnmappedAssets(isIncludeignore);
        await fetchMappedAssets();
        setShowModel(false);
    }
   };

   const handleCreateNewAsset = async () => {
    const data = {
        assetName: securityName,
        securityTypeId: selectedSecurityTypeId,
        strategyId: selectedStrategyId,
        inceptionDate: inceptionDate?.toISOString() || null
    };
    if(data?.assetName?.trim().length<=0)
    {
        toast.error("Please Enter the Asset Name");
        return;
     }
    if(!data?.inceptionDate?.trim().length>0)
    {
        toast.error("Please Choose a Inception Date");
        return;
        
    }
    if(!data?.strategyId>0)
    {
        toast.error("Please Selected a Strategy");
        return;
    }
    if(!data?.securityTypeId>0)
    {
        toast.error("Please Select a Asset Type");
        return;
    }
    try{
        await sbaAxios({
            url: insertAsset,
            data: data,
            method: 'post'
        });
        toast.success("New Asset Created Successfully.");
        setShowAddDrawer(false);
        fetchNewAssets();
    }
    catch(e){
        toast.error("Unable to create New Asset.");
    }
    finally{
       
    };
   };

   const handleReload = async() => {
    try{
        await sbaAxios({
            url: portfolioSummarize,
            params:{
                portfolioId: selectedPortfolioId
            },
            method: 'post'
        });
        toast.success('Portfolio summary reloaded.')
    }
    catch(e){
        toast.error('Unable reload portfolio summary.')
    }
   };

const chkchangeshowIgnore=(val)=>
{
   const isshowignore=val===true?false:true;
   setIsCheckedIgnore(val);
    setIsIncludeIgnore(isshowignore);
    fetchUnmappedAssets(isshowignore);
}
   return(
     <>
        <div className="contaier-fluid mt-4 mx-2">
            <div className="col">
                <div className="row">
                <div className="col-md-4">
                    <label className="label" >Portfolio</label>
                    <div>
                        <SBAComboBox
                            className="w-100"
                            data={portfolioList}
                            textField={"PortfolioName"}
                            valueField={"PortfolioId"}
                            value={selectedPortfolio}
                            onChange={handleSelectedPortfolio}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                </div>
                <span style={{width:"5px"}}>
                </span>
                <div className="col-md-2">
                    <p style={{ display: 'flex', alignItems: 'center', marginTop:'25px' ,gap:'10px'}}>
                        <input
                            type="checkbox"
                            checked={checkAllPortfolio}
                            onChange={() => setCheckAllPortfolio(!checkAllPortfolio)}
                        />
                        <label className="label">Get all portfolios</label>
                    </p>
                </div>
                </div>
                <div className="row mt-4">
                <div className="col-md-4">
                    <label className="label" >Map to asset</label>
                    <div>
                        <SBAComboBox
                            className="w-100"
                            data={assetList}
                            textField={"AssetName"}
                            valueField={"AssetId"}
                            value={selectedAsset}
                            onChange={handleSelectedAsset}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                </div>
                <span style={{width:"10px"}}>
                </span>
                <div className="col-md-1">
                    <p style={{ display: 'flex', alignItems: 'center', marginTop:'25px' ,gap:'10px'}}>
                        <input
                            type="checkbox"
                            checked={checkAllAssets}
                            onChange={() => setCheckAllAssets(!checkAllAssets)}
                        />
                        <label className="label">Get all Assets</label>
                    </p>
                </div>
                <div className="col-md-2">
                    <div style={{ display: 'flex', alignItems: 'center', marginTop:'20px'}}>
                    <button className="p-sm-btn" onClick={()=>{setShowAddDrawer(true)}} disabled={unmappedAssetList.length === 0}>Create New Asset</button>
                    </div>
                </div>
                </div>
                   <div className="row mt-4">
                       <div><h5>Unmapped Assets</h5></div>
                       
                <div class="col-8 bg-white  rounded">
                <div className="d-flex justify-content-end gap-2">
                           <div className="d-inline-flex ">
                           <p style={{ display: 'flex', alignItems: 'center',gap:'10px'}}>  
                           <input
                            type="checkbox"
                            checked={ischeckedignore}
                            onChange={(e) => chkchangeshowIgnore(e.target.checked)}
                        />
                        <label className="label">Show Ignored</label>
                    </p>
                           </div>
                       </div>
                        <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}> 
                            <AgGridReact 
                                columnDefs={unmappedColumnDef} 
                                rowData={unmappedAssetList} 
                                onCellValueChanged={handleUnmappedSelection} 
                                components={{
                                    selectAllHeader: SelectAllHeader
                                }} 
                                defaultColDef={{resizable:true}}
                            ></AgGridReact>
                        </div>
                    </div>
                    <div>
                    <button className="p-sm-btn mx-1 mt-1" onClick={handleMapAssets} disabled={selectedUnmappedAssets.length === 0 || selectedAssetId === 0}>Map Asset</button>
                    </div>
                </div>
                <div className="row mt-4">
                <div><h5>Mapped Assets</h5></div>
                <div class="col-8 bg-white  rounded">
                        <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}> 
                            <AgGridReact columnDefs={mappedColumnDef} rowData={mappedAssetList} defaultColDef={{resizable:true}}></AgGridReact>
                        </div>
                    </div>
                    <div>
                    <button className="p-sm-btn mx-1 mt-1" onClick={handleReload} disabled={selectedPortfolioId === 0}>Reload Portfolio Summary</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <SBADrawer
              open={showAddDrawer} 
              setOpen={setShowAddDrawer} 
              style={{ width: "70vw" }} 
              title="Create New Asset"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="my-4">
                                <label className="label">Asset Name<span className="mandatory">*</span></label>
                                <input
                                    className="form-control w-75"
                                    type="text"
                                    value={securityName}
                                    onChange={(e) => {setSecurityName(e.target.value)}}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="my-4">
                                <label className="label">Asset Type<span className="mandatory">*</span>
                                </label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={securityType}
                                        textField={"AssetTypeName"}
                                        valueField={"AssetTypeId"}
                                        value={selectedSecurityType}
                                        onChange={handleSecurityTypeChange}
                                        popupSettings={{ className: "modalDD" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="my-4">
                                <label className="label">Strategy<span className="mandatory">*</span>
                                </label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={strategy}
                                        textField={"ClassificationValue"}
                                        valueField={"ClassificationId"}
                                        value={selectedStrategy}
                                        onChange={handleStrategyChange}
                                        popupSettings={{ className: "modalDD" }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="my-4">
                                <label className="label">Inception Date	</label>
                                <div>
                                    <SBDatePicker 
                                        className="w-75" 
                                        value={moment(inceptionDate)} 
                                        onChange={(newDate)=>{setInceptionDate(newDate)}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="m-1 d-flex justify-content-end mt-4">
                <button className="s-sm-btn mx-1" onClick={() => { setShowAddDrawer(false) }}>Cancel</button>
                <button className="p-sm-btn mx-1" onClick={handleCreateNewAsset}>Create New Asset</button>
                </div>
            </SBADrawer>
        </div>
        {showModel && (
        <Modal show={showModel} onHide={() => setShowModel(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Unmap Asset</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you really want to unmap selected asset?</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleUnmap}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}
     </>
    )

}

// const SelectAllHeader = (props) => {
//     console.log('props:', props)
//     const handleChange = (e) => {
//       const checked = e.target.checked;
//       const updatedRows = props.api.getDisplayedRowCount();
  
//       for (let i = 0; i < updatedRows; i++) {
//         const rowNode = props.api.getDisplayedRowAtIndex(i);
//         rowNode.setDataValue("select", checked);
//       }
//     };
  
//     return <span style={{ color: '#545454', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '10px' }}>
//     <input type="checkbox" onChange={handleChange} />
//     Select
//   </span>;
//   };
  

export default NewAssets